

export default {
  props: {
    diagramIds: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: () => ({
    specialOffers: []
  }),
  async fetch () {
    this.specialOffers = await this.$backend.specialOffers.get({ diagram_ids: this.diagramIds.join(',') })
  },
  computed: {
    specialOfferClasses () {
      if (this.specialOffers.length > 1) {
        return 'lg:grid-cols-2 grid-cols-1'
      } else {
        return 'flex'
      }
    }
  }
}

